var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgNoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_noti"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.5062 63.1447L29.0809 65.1753C28.5763 65.3642 28.3174 65.95 28.5025 66.4838L34.4022 83.489C34.5874 84.0227 35.1465 84.3022 35.651 84.1134L41.0763 82.0828C41.5809 81.8939 41.8399 81.3081 41.6547 80.7743L35.755 63.7691C35.5698 63.2354 35.0107 62.9559 34.5062 63.1447Z",
    stroke: "#999999",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.6385 60.9173L32.7293 43.8782C32.4595 43.1 32.6658 42.2561 33.2529 41.7367L46.111 30.3629L57.5805 20.6645C58.6296 19.7775 60.2796 20.2947 60.7527 21.6589L73.4915 58.3892C73.9422 59.6886 73.053 60.9995 71.7231 60.9962L49.401 60.9409",
    stroke: "#999999",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.8328 46.8014L32.2695 41.0252C32.3705 40.9874 32.4823 41.0433 32.5193 41.1501L39.6957 61.8454C39.7327 61.9521 39.6809 62.0693 39.58 62.107L24.1432 67.8832C24.0423 67.921 23.9305 67.8651 23.8935 67.7583L16.7171 47.063C16.6801 46.9563 16.7319 46.8391 16.8328 46.8014Z",
    fill: "#F5F5F5",
    stroke: "#999999",
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 38",
    d: "M77.7024 35.0386L91.7924 29.802",
    stroke: "#999999",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 39",
    d: "M74.5544 27.0596L82.6871 18.7533",
    stroke: "#999999",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 40",
    d: "M92.2866 44.2461L80.91 43.1906",
    stroke: "#999999",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 973",
    cx: 67,
    cy: 40.0349,
    r: 6,
    fill: "#F7E237"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNoti);
export default __webpack_public_path__ + "static/media/img_noti.101f1934f4dae63c21fcb734777fe434.svg";
export { ForwardRef as ReactComponent };